<div class="padded-container">

    <dx-accordion>
        <dxi-item title="{{ 'ProblemsToBeSolved' | translate }}" [expanded]="true">
            <div *ngIf="registeredCarFaultsResponse?.carFaults?.length">
                <div *ngFor="let fault of registeredCarFaultsResponse?.carFaults">
                    <dx-text-area [(value)]="fault.faultNotes" class="full-width-button" [readOnly]="true"></dx-text-area>
                    <dx-check-box [(value)]="fault.picked" text="{{ 'Picked' | translate }}"></dx-check-box>
                </div>
            </div>
            <div *ngIf="!registeredCarFaultsResponse?.carFaults?.length">
                <span>{{ 'NoRegisteredCarFaults' | translate }}</span>
            </div>
        </dxi-item>
    </dx-accordion>

    <div *ngFor="let comment of comments">
        <dx-text-area [(ngModel)]="comment.text" class="full-width-button" placeholder="{{ 'TypeYourCommentHere' | translate }}" [autoResizeEnabled]="true"></dx-text-area>
    </div>

    <dx-button text="{{ 'AdditionalComment' | translate }}" (onClick)="addComment()" class="full-width-button" type="default"></dx-button>

    <dx-button text="{{ 'Continue' | translate }}" (onClick)="continueNextStep()" class="full-width-button" type="success"></dx-button>

    <dx-button text="{{ 'Back' | translate }}" (onClick)="navigateToServicePickCar()" class="full-width-button" type="danger"></dx-button>
</div>